import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import PageContainer from "./PageContainer";
import Footer from "./Footer";

const AppShell = () => (
  <Box className="app-shell">
    <NavBar />
    <Box component="main" sx={{ flex: 1, py: { xs: 4, md: 6 } }}>
      <PageContainer>
        <Outlet />
      </PageContainer>
    </Box>
    <Footer />
  </Box>
);

export default AppShell;
